import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SeoService } from 'src/app/services/seo.service';

/** Applies `routeSeo.home` meta and JSON-LD before SSR render (and client navigation). */
export const homePageSeoResolver: ResolveFn<true> = () => {
  inject(SeoService).applyFromRouter();
  return true;
};
